(() => {
  if (window.__themumeProductControlsLoaded) return;
  window.__themumeProductControlsLoaded = true;

  const rootUrl = () => window.Shopify?.routes?.root || '/';

  const protectionStorageKey = 'themume-shipping-protection';

  function protectionDisabled() {
    return localStorage.getItem(protectionStorageKey) === 'off';
  }

  function protectionVariantId(scope = document) {
    const marker = scope.querySelector?.('[data-sp-variant-id]');
    const id = Number(marker?.dataset?.spVariantId || marker?.value);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
  }

  function syncProtectionInputs(scope = document) {
    const disabled = protectionDisabled();
    scope.querySelectorAll?.('[data-sp-additional-item]').forEach((input) => {
      input.disabled = disabled;
    });
  }

  async function ensureShippingProtection(scope) {
    if (protectionDisabled()) return;
    const variantId = protectionVariantId(scope);
    if (!variantId) return;

    const cartResponse = await fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } });
    const cart = await cartResponse.json();
    if (!cartResponse.ok) throw new Error('Unable to verify shipping protection.');

    const line = cart.items?.find((item) => Number(item.variant_id) === variantId);
    if (line?.quantity === 1) return;

    const url = line
      ? (window.routes?.cart_change_url || rootUrl() + 'cart/change.js')
      : (window.routes?.cart_add_url || rootUrl() + 'cart/add.js');
    const body = line
      ? { id: line.key, quantity: 1 }
      : { items: [{ id: variantId, quantity: 1, properties: { _shipping_protection: 'true' } }] };
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const payload = await response.json();
    if (!response.ok || payload?.status) {
      throw new Error(payload?.description || payload?.message || 'Unable to add shipping protection.');
    }
  }

  function productFormData(form) {
    const data = new FormData(form);
    Array.from(data.keys()).forEach((key) => {
      if (String(key).startsWith('shopify-additional-items[')) data.delete(key);
    });
    return data;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const submitter = event.submitter;
    if (!(form instanceof HTMLFormElement)
      || !form.matches('form[data-type="add-to-cart-form"]')
      || !form.querySelector('[data-sp-variant-id]')
      || !submitter?.matches?.('[name="add"]')
      || form.dataset.spReady === 'true'
      || protectionDisabled()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    submitter.disabled = true;
    submitter.setAttribute('aria-disabled', 'true');

    try {
      await ensureShippingProtection(form);
      form.dataset.spReady = 'true';
      form.querySelectorAll('[data-sp-additional-item]').forEach((input) => { input.disabled = true; });
      submitter.disabled = false;
      submitter.removeAttribute('aria-disabled');
      form.requestSubmit(submitter);
    } catch (error) {
      form.closest('product-form')?.handleErrorMessage?.(error.message || 'Unable to add shipping protection.');
      submitter.disabled = false;
      submitter.removeAttribute('aria-disabled');
    } finally {
      window.setTimeout(() => {
        delete form.dataset.spReady;
        syncProtectionInputs(form);
      }, 1200);
    }
  }, true);

  function neutralizeExternalBuyNowMarkers() {
    document.querySelectorAll('.tm-dynamic-checkout').forEach((dynamicCheckout) => {
      dynamicCheckout.setAttribute('data-skip-cart-button', 'true');
      dynamicCheckout.querySelectorAll([
        'shopify-accelerated-checkout',
        'shopify-pay-button',
        '[data-shopify="payment-button"]',
        '.shopify-payment-button',
        '[data-shopify="dynamic-checkout-button"]',
      ].join(',')).forEach((element) => {
        element.setAttribute('data-skip-cart-button', 'true');
        element._ttOverlaid = true;
        element.querySelectorAll('[data-tt-overlay="1"]').forEach((overlay) => overlay.remove());
      });
      dynamicCheckout.querySelectorAll('[data-tt-buy-now="1"], .tt-buy-now-button').forEach((element) => {
        element.removeAttribute('data-tt-buy-now');
        element.classList.remove('tt-buy-now-button');
      });
    });
  }

  syncProtectionInputs();
  neutralizeExternalBuyNowMarkers();
  window.addEventListener('storage', () => syncProtectionInputs());
  new MutationObserver(() => {
    syncProtectionInputs();
    neutralizeExternalBuyNowMarkers();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-tt-buy-now', 'class'],
  });

  async function buyNow(button, checkoutUrl = `${rootUrl()}checkout`) {
    if (button.disabled || button.classList.contains('loading')) return;
    const productForm = button.closest('product-form');
    const form = productForm?.querySelector('form[data-type="add-to-cart-form"]');
    const submit = productForm?.querySelector('[name="add"]');
    if (!form || submit?.disabled || submit?.getAttribute('aria-disabled') === 'true') return;

    const spinner = button.querySelector('.loading__spinner');
    button.disabled = true;
    button.classList.add('loading');
    spinner?.classList.remove('hidden');

    try {
      await ensureShippingProtection(form);
      const response = await fetch(window.routes?.cart_add_url || `${rootUrl()}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: productFormData(form),
      });
      const payload = await response.json();
      if (!response.ok || payload?.status) throw new Error(payload?.description || payload?.message || 'Unable to start checkout.');
      window.location.assign(
        button.matches('.tm-quick-pay-button')
          ? rootUrl() + 'checkout?payment=shop_pay'
          : rootUrl() + 'checkout'
      );
    } catch (error) {
      productForm?.handleErrorMessage?.(error.message || 'Unable to start checkout.');
      button.disabled = false;
      button.classList.remove('loading');
      spinner?.classList.add('hidden');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.tm-buy-now-button, .tm-quick-pay-button');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    buyNow(button, button.matches('.tm-quick-pay-button') ? `${rootUrl()}checkout?payment=shop_pay` : `${rootUrl()}checkout`);
  }, true);

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.optionValueSelectionChange) {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
      data?.event?.target?.closest('product-info')?.querySelectorAll('.tm-buy-now-button, .tm-quick-pay-button').forEach((button) => { button.disabled = true; });
    });
  }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      document.querySelector(`#MainProduct-${CSS.escape(String(data?.sectionId))}`)?.querySelectorAll('.tm-buy-now-button, .tm-quick-pay-button').forEach((button) => { button.disabled = !data?.variant?.available; });
    });
  }
})();
